import styled, { keyframes } from "styled-components";

export const wave = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-15px);
  }
`;

export const CircleNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(28, 28, 28, 0.69);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  color: rgba(28, 28, 28, 0.69);
`;

export const DescriptionTitle = styled.div`
  font-family: Inter;
  font-weight: 300;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
`;

export const WrapperCardsPayment = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 80px;
  margin-top: 40px;
`;

export const Dot = styled.div<{ delay: number }>`
  width: 12px;
  height: 12px;
  background-color: #6b7280;
  border-radius: 50%;
  animation: ${wave} 1.2s infinite ease-in-out;
  animation-delay: ${(props) => props.delay}s;
`;